export const LabelType = Object.freeze({
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  IN_PROGRESS: 'IN_PROGRESS',
  WARN: 'WARN',
});
